import React, { useState } from "react";
import { addToast } from "@heroui/react";
import { NFTCollectionsList } from "../../../../api/methods-marketplace";
import { useNavigate } from "react-router-dom";

const NotificationCard = ({ data, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCardClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (loading) return;

    try {
      setLoading(true);
      const result = await NFTCollectionsList();
      const collections = result?.data?.data || [];
      const notificationId = data?.detail?.id;
      const matched = collections.find(
        (collection) => String(collection.id) === String(notificationId)
      );

      if (matched?.address) {
        if (onClose) {
          onClose();
        }

        navigate(`/item-details/${matched.address}`);
      } else {
        addToast({
          title: "Collection not found",
          description: "Sorry, we couldn't find the collection.",
          color: "danger",
          variant: "bordered"
        });
      }
    } catch (err) {
      console.error("❌ Error fetching collections:", err);

      addToast({
        title: "Error",
        description: "Unable to fetch NFT collections.",
        color: "danger",
        variant: "bordered"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={(e) => e.key === "Enter" && handleCardClick(e)}
      className="cursor-pointer w-full"
    >
      <div className="py-2 px-3 bg-[#E9E9E9] flex items-center gap-2.5 rounded-md min-h-10 hover:bg-[#DDDDDD] transition-colors">
        <div className="w-2 h-2 rounded-full bg-[#71B243]" />
        <div className="flex-1">
          <p className="m-0 text-sm text-black font-normal">
            {data?.msg || "Notification"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
